import z from 'zod'

export const ChargeStatusSchema = z.enum(['On Hold', 'Rejected', 'Replacement'])

export type ChargeStatus = z.infer<typeof ChargeStatusSchema>
